// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3DeA7","productName":"Table_productName__3p4y0"};